import { Operand } from '../../api/Argentia/endpoints/operands/model/operand'
import { PriceCoefficientTable } from '../../api/Argentia/endpoints/priceCoefficients/model/PriceCoefficient'
import { PriceCalculationTypeCompatibility } from '../../api/Argentia/endpoints/pricing/model/priceType'
import { PriceDetails, PriceVersion } from '../../pages/pricing/pricing.Model'

export enum PricingActionTypes {
  STORE_ACTIVE_PRICE = 'STORE_ACTIVE_PRICE',
  STORE_ACTIVE_VERSIONS = 'STORE_ACTIVE_VERSIONS',
  STORE_OPERANDS = 'STORE_OPERANDS',
  STORE_COMPATIBLES_CALCULATION_PRICE_TYPE = 'STORE_COMPATIBLES_CALCULATION_PRICE_TYPE',
  STORE_COMPATIBLES_PRICE_TYPE = 'STORE_COMPATIBLES_PRICE_TYPE',
  STORE_COEFFICIENTS = 'STORE_COEFFICIENTS'
}

export interface StoreActivePriceAction {
  type: PricingActionTypes
  payload: PriceDetails | null
}

export interface StoreVersionsAction {
  type: PricingActionTypes
  payload: PriceVersion[] | null
}

export interface StoreOperandsAction {
  type: PricingActionTypes
  payload: Operand[]
}

export interface StoreCompatibleCalculationTypesAction {
  type: PricingActionTypes
  payload: PriceCalculationTypeCompatibility[]
}

export interface StoreCoefficientsAction {
  type: PricingActionTypes
  payload: PriceCoefficientTable[] | null
}

export const storeActivePriceAction = (price: PriceDetails | null): StoreActivePriceAction => {
  return { type: PricingActionTypes.STORE_ACTIVE_PRICE, payload: price }
}

export const storeVersionsAction = (versions: PriceVersion[] | null): StoreVersionsAction => {
  return { type: PricingActionTypes.STORE_ACTIVE_VERSIONS, payload: versions }
}

export const storeOperandsAction = (operands: Operand[]): StoreOperandsAction => {
  return { type: PricingActionTypes.STORE_OPERANDS, payload: operands }
}

export const storeCalculationTypesAction = (
  calculationTypes: PriceCalculationTypeCompatibility[]
): StoreCompatibleCalculationTypesAction => {
  return {
    type: PricingActionTypes.STORE_COMPATIBLES_CALCULATION_PRICE_TYPE,
    payload: calculationTypes
  }
}

export const storeCoefficientsAction = (
  coefficients: PriceCoefficientTable[] | null
): StoreCoefficientsAction => {
  return { type: PricingActionTypes.STORE_COEFFICIENTS, payload: coefficients }
}
